import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import'rxjs/add/operator/map';
import'rxjs/add/operator/catch';
import'rxjs/add/observable/throw';
import { AuthConfiguration } from '../modules/auth.configuration';
import { OidcSecurityCommon } from './oidc.security.common';
export class AuthWellKnownEndpoints {

    issuer: string;
    jwks_uri: string;
    authorization_endpoint: string;
    token_endpoint: string;
    userinfo_endpoint: string;
    end_session_endpoint: string;
    check_session_iframe: string;
    revocation_endpoint: string;
    introspection_endpoint: string;
/**
 * @param {?} http
 * @param {?} authConfiguration
 * @param {?} oidcSecurityCommon
 */
constructor(
private http: Http,
private authConfiguration: AuthConfiguration,
private oidcSecurityCommon: OidcSecurityCommon
    ) {
        let data = this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_well_known_endpoints);
        this.oidcSecurityCommon.logDebug(data);
        if (data && data !== '') {
            this.oidcSecurityCommon.logDebug('AuthWellKnownEndpoints already defined');
            this.issuer = data.issuer;
            this.jwks_uri = data.jwks_uri;
            this.authorization_endpoint = data.authorization_endpoint;
            this.token_endpoint = data.token_endpoint;
            this.userinfo_endpoint = data.userinfo_endpoint;

            if (data.end_session_endpoint) {
                this.end_session_endpoint = data.end_session_endpoint;

            };

            if (data.check_session_iframe) {
                this.check_session_iframe = data.check_session_iframe;
            };

            if (data.revocation_endpoint) {
                this.revocation_endpoint = data.revocation_endpoint;
            };

            if (data.introspection_endpoint) {
                this.introspection_endpoint = data.introspection_endpoint;
            }
        } else {
            this.oidcSecurityCommon.logDebug('AuthWellKnownEndpoints first time, get from the server');
            this.getWellKnownEndpoints()
                .subscribe((data: any) => {
                    this.issuer = data.issuer;
                    this.jwks_uri = data.jwks_uri;
                    this.authorization_endpoint = data.authorization_endpoint;
                    this.token_endpoint = data.token_endpoint;
                    this.userinfo_endpoint = data.userinfo_endpoint;

                    if (data.end_session_endpoint) {
                        this.end_session_endpoint = data.end_session_endpoint;
                    };

                    if (data.check_session_iframe) {
                        this.check_session_iframe = data.check_session_iframe;
                    };

                    if (data.revocation_endpoint) {
                        this.revocation_endpoint = data.revocation_endpoint;
                    };

                    if (data.introspection_endpoint) {
                        this.introspection_endpoint = data.introspection_endpoint;
                    }

                    this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_well_known_endpoints, data);
                    this.oidcSecurityCommon.logDebug(data);
                });
        }
    }
private getWellKnownEndpoints = (): Observable<any> => {

        let /** @type {?} */ headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');

        let /** @type {?} */ url = this.authConfiguration.stsServer + '/.well-known/openid-configuration';
        if (this.authConfiguration.override_well_known_configuration) {
            url = this.authConfiguration.override_well_known_configuration_url;
        }

        return this.http.get(url, {
            headers: headers,
            body: ''
        }).map((res: any) => res.json());
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: AuthConfiguration, },
{type: OidcSecurityCommon, },
];
}

function AuthWellKnownEndpoints_tsickle_Closure_declarations() {
/** @type {?} */
AuthWellKnownEndpoints.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AuthWellKnownEndpoints.ctorParameters;
/** @type {?} */
AuthWellKnownEndpoints.prototype.issuer;
/** @type {?} */
AuthWellKnownEndpoints.prototype.jwks_uri;
/** @type {?} */
AuthWellKnownEndpoints.prototype.authorization_endpoint;
/** @type {?} */
AuthWellKnownEndpoints.prototype.token_endpoint;
/** @type {?} */
AuthWellKnownEndpoints.prototype.userinfo_endpoint;
/** @type {?} */
AuthWellKnownEndpoints.prototype.end_session_endpoint;
/** @type {?} */
AuthWellKnownEndpoints.prototype.check_session_iframe;
/** @type {?} */
AuthWellKnownEndpoints.prototype.revocation_endpoint;
/** @type {?} */
AuthWellKnownEndpoints.prototype.introspection_endpoint;
/** @type {?} */
AuthWellKnownEndpoints.prototype.getWellKnownEndpoints;
/** @type {?} */
AuthWellKnownEndpoints.prototype.http;
/** @type {?} */
AuthWellKnownEndpoints.prototype.authConfiguration;
/** @type {?} */
AuthWellKnownEndpoints.prototype.oidcSecurityCommon;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
